import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { ArrowBack as ArrowBackIcon } from '@material-ui/icons';
import { IconButton, Typography, Button } from '@material-ui/core';

import { inputFieldNames } from '../../constants';

import RecordsList from './RecordsList';
import calculateNextEventDate from '../../mappers/calculateNextEventDate';
import { submitMode } from '../../constants';
import AddEventRecordDialog from '../../containers/AddEventRecordDialog';

const useStyles = makeStyles((theme) => ({
  simpleLabel: {
    display: 'inline-block',
    marginTop: 2
  },
  editEventFieldsContainer: {
    padding: theme.spacing(2)
  },
  backArrow: {
    marginLeft: -16
  },
  eventName: {
    fontWeight: 600
  },
  addRecordButton: {
    marginTop: 8
  }
}));

const EditEventPanel = (props) => {
  const {
    event,
    openEditEventPanel,
    fetchRecordsForTheEvent,
    records,
    onHandleDeleteEventRecordClick,
    submitRecord,
    enableEditEventRecord,
    isEditRecordEnabled,
    recordBeingEdited,
    onHandleEditEventRecordInputChange,
    onOpenAddEventRecordDialog,
    openAddEventRecordDialog,
    userId,
    onRemoveAttachment,
    allAttachments,
    branchId
  } = props;
  const classes = useStyles();

  React.useEffect(
    () => {
      fetchRecordsForTheEvent(event.id);
    },

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [event.id]
  );

  const handleEditEventRecordInputChange = (e, inputfieldName) => {
    if (
      inputfieldName === inputFieldNames.RECORD_DATE ||
      inputfieldName === inputFieldNames.EVENT_RECORD_ATTACHMENT
    ) {
      onHandleEditEventRecordInputChange(e, inputfieldName);
    } else {
      onHandleEditEventRecordInputChange(e.target.value, inputfieldName);
    }
  };

  const handleDeleteEventRecordClick = (recordId) => {
    const payload = {
      eventId: event.id,
      recordId
    };
    onHandleDeleteEventRecordClick(payload);
  };

  const handleRemoveAttachment = (attachment) => {
    onRemoveAttachment(attachment);
  };

  const handleSaveEventRecordClick = (e) => {
    e.preventDefault();

    const payload = {
      eventId: event.id,
      ...recordBeingEdited,
      nextEventDate: calculateNextEventDate(
        recordBeingEdited.recordDate,
        event.frequency
      )
    };

    submitRecord(payload, submitMode.UPDATE, branchId);
  };

  return (
    <React.Fragment>
      {openAddEventRecordDialog ? <AddEventRecordDialog /> : null}

      <div className={classes.backArrowContainer}>
        <IconButton
          aria-label="show 4 new mails"
          color="inherit"
          onClick={() => openEditEventPanel(false)}
          id="settings-button"
          className={classes.backArrow}
        >
          <ArrowBackIcon color="primary" />
        </IconButton>
        <Typography className={classes.simpleLabel}>Events</Typography>
      </div>

      <div className={classes.courseNameContainer}>
        <Typography className={classes.eventName}>
          {event.description}
        </Typography>
      </div>

      <Button
        color="primary"
        variant="contained"
        className={classes.addRecordButton}
        onClick={() => onOpenAddEventRecordDialog(true)}
      >
        Add Record
      </Button>

      {/* <AddRecord
        record={record}
        handleInputChange={handleInputChange}
        handleSubmitRecord={handleSubmitRecord}
      /> */}

      <RecordsList
        records={records}
        handleDeleteEventRecordClick={handleDeleteEventRecordClick}
        enableEditEventRecord={enableEditEventRecord}
        isEditRecordEnabled={isEditRecordEnabled}
        recordBeingEdited={recordBeingEdited}
        handleEditEventRecordInputChange={handleEditEventRecordInputChange}
        handleSaveEventRecordClick={handleSaveEventRecordClick}
        userId={userId}
        handleRemoveAttachment={handleRemoveAttachment}
        allAttachments={allAttachments}
      />
    </React.Fragment>
  );
};

export default EditEventPanel;
